module.exports = __webpack_public_path__ + "media/images/icon__calendar-f0801fe1cfbd30580ba7811596b45729.png";